import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=5ed79099&scoped=true&lang=pug"
import script from "./advert.vue?vue&type=script&lang=js"
export * from "./advert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed79099",
  null
  
)

export default component.exports